module.exports = __webpack_public_path__ + "static/media/Paymentupihide.84b3c53e.svg";